import colors from '../colors';
export var MuiRadio = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: {
            '&:hover circle': {
                stroke: colors.blue[500],
            },
            '&:hover.Mui-checked circle': {
                stroke: colors.blue[300],
            },
            '&.Mui-disabled circle': {
                stroke: colors.grey[300],
            },
            '&.Mui-disabled.Mui-checked circle': {
                stroke: colors.blue[300],
            },
        },
    },
};
